import type { FaireProductEntity } from "../../entity_types/product";

export const p_979s7d9zse: FaireProductEntity = {
  token: "p_979s7d9zse",
  type: "product",
  name: "Gold Foil Birthday Assortment",
  brandName: "Masterpiece Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/8ca90ce06698f4a9ff75b98d7a2602714772d313b25618764a344bf1c42afd3f.jpeg",
  priceDollars: 6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/0d5035d5ea6f1931345a72d6c35aef3905874c2d825ba6f15f6297ff998bb6f6.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
